export default [
  {
    path: '/app/hr-forms',
    name: 'HrForms',
    component: () => import('@/views/Admin/HrForms/Index.vue'),
    meta: {
      pageTitle: 'Kariyer Başvuruları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_HR_FORMS_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/hr-forms/view/:id',
    name: 'HrFormView',
    component: () => import('@/views/Admin/HrForms/View.vue'),
    meta: {
      pageTitle: 'Kariyer Başvuruları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/hr-forms',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'ADMIN_HR_FORMS_LIST',
      action: 'read',
    },
  },
]
